__turbopack_context__.v({
  "backdrop": "QuickAddPopover-module-scss-module__uOVkxa__backdrop",
  "backdropHidden": "QuickAddPopover-module-scss-module__uOVkxa__backdropHidden",
  "cellSelected": "QuickAddPopover-module-scss-module__uOVkxa__cellSelected",
  "closeButton": "QuickAddPopover-module-scss-module__uOVkxa__closeButton",
  "colourLabel": "QuickAddPopover-module-scss-module__uOVkxa__colourLabel",
  "colourLabelName": "QuickAddPopover-module-scss-module__uOVkxa__colourLabelName",
  "colourLabelRow": "QuickAddPopover-module-scss-module__uOVkxa__colourLabelRow",
  "colourRow": "QuickAddPopover-module-scss-module__uOVkxa__colourRow",
  "colourSection": "QuickAddPopover-module-scss-module__uOVkxa__colourSection",
  "errorMessage": "QuickAddPopover-module-scss-module__uOVkxa__errorMessage",
  "fallback": "QuickAddPopover-module-scss-module__uOVkxa__fallback",
  "header": "QuickAddPopover-module-scss-module__uOVkxa__header",
  "headerDesktop": "QuickAddPopover-module-scss-module__uOVkxa__headerDesktop",
  "headerSheet": "QuickAddPopover-module-scss-module__uOVkxa__headerSheet",
  "popup": "QuickAddPopover-module-scss-module__uOVkxa__popup",
  "popupChip": "QuickAddPopover-module-scss-module__uOVkxa__popupChip",
  "popupDesktop": "QuickAddPopover-module-scss-module__uOVkxa__popupDesktop",
  "popupSheet": "QuickAddPopover-module-scss-module__uOVkxa__popupSheet",
  "popupSheetSuccess": "QuickAddPopover-module-scss-module__uOVkxa__popupSheetSuccess",
  "popupStacked": "QuickAddPopover-module-scss-module__uOVkxa__popupStacked",
  "positioner": "QuickAddPopover-module-scss-module__uOVkxa__positioner",
  "positionerChip": "QuickAddPopover-module-scss-module__uOVkxa__positionerChip",
  "positionerDesktop": "QuickAddPopover-module-scss-module__uOVkxa__positionerDesktop",
  "positionerSheet": "QuickAddPopover-module-scss-module__uOVkxa__positionerSheet",
  "positionerSheetSuccess": "QuickAddPopover-module-scss-module__uOVkxa__positionerSheetSuccess",
  "positionerStacked": "QuickAddPopover-module-scss-module__uOVkxa__positionerStacked",
  "quickAddPulse": "QuickAddPopover-module-scss-module__uOVkxa__quickAddPulse",
  "sizeGrid": "QuickAddPopover-module-scss-module__uOVkxa__sizeGrid",
  "sizeGridDesktop": "QuickAddPopover-module-scss-module__uOVkxa__sizeGridDesktop",
  "sizeGridSheet": "QuickAddPopover-module-scss-module__uOVkxa__sizeGridSheet",
  "sizeGridStacked": "QuickAddPopover-module-scss-module__uOVkxa__sizeGridStacked",
  "skeletonCell": "QuickAddPopover-module-scss-module__uOVkxa__skeletonCell",
  "spinnerWrapper": "QuickAddPopover-module-scss-module__uOVkxa__spinnerWrapper",
  "success": "QuickAddPopover-module-scss-module__uOVkxa__success",
  "successIcon": "QuickAddPopover-module-scss-module__uOVkxa__successIcon",
  "successLabel": "QuickAddPopover-module-scss-module__uOVkxa__successLabel",
  "successLabelChip": "QuickAddPopover-module-scss-module__uOVkxa__successLabelChip",
  "successLabelStacked": "QuickAddPopover-module-scss-module__uOVkxa__successLabelStacked",
  "summary": "QuickAddPopover-module-scss-module__uOVkxa__summary",
  "summaryImage": "QuickAddPopover-module-scss-module__uOVkxa__summaryImage",
  "summaryImg": "QuickAddPopover-module-scss-module__uOVkxa__summaryImg",
  "summaryInfo": "QuickAddPopover-module-scss-module__uOVkxa__summaryInfo",
  "summaryName": "QuickAddPopover-module-scss-module__uOVkxa__summaryName",
  "summaryOriginalPrice": "QuickAddPopover-module-scss-module__uOVkxa__summaryOriginalPrice",
  "summaryPrice": "QuickAddPopover-module-scss-module__uOVkxa__summaryPrice",
  "surface": "QuickAddPopover-module-scss-module__uOVkxa__surface",
  "surfaceChip": "QuickAddPopover-module-scss-module__uOVkxa__surfaceChip",
  "surfaceDesktop": "QuickAddPopover-module-scss-module__uOVkxa__surfaceDesktop",
  "surfacePanel": "QuickAddPopover-module-scss-module__uOVkxa__surfacePanel",
  "surfaceSheet": "QuickAddPopover-module-scss-module__uOVkxa__surfaceSheet",
  "surfaceStacked": "QuickAddPopover-module-scss-module__uOVkxa__surfaceStacked",
  "surfaceSuccess": "QuickAddPopover-module-scss-module__uOVkxa__surfaceSuccess",
  "titleDesktop": "QuickAddPopover-module-scss-module__uOVkxa__titleDesktop",
  "titleHidden": "QuickAddPopover-module-scss-module__uOVkxa__titleHidden",
  "titleSheet": "QuickAddPopover-module-scss-module__uOVkxa__titleSheet",
  "titleStacked": "QuickAddPopover-module-scss-module__uOVkxa__titleStacked",
  "viewProductLink": "QuickAddPopover-module-scss-module__uOVkxa__viewProductLink",
});
